import { createRouter, createWebHistory } from 'vue-router'
import PersonalPortfolio from '../views/PersonalPortfolio.vue'

const routes = [
  {
    path: '/',
    name: 'PersonalPortfolio',
    component: PersonalPortfolio
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
